import { Component, Input } from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { NgxCurrencyDirective } from 'ngx-currency';
import { DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { MaskService } from '../../../../../shared/services/mask.service';
import { CustomDateAdapter } from '../../../../../shared/services/custom-date-adapter';
import { EmptyStateComponent } from '../../../../../shared/components/empty-state/empty-state.component';
import { AbntPipe } from '@shared/pipes/abnt.pipe';

@Component({
  selector: 'app-produto-custos',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    MatDatepickerModule,
    MatTooltipModule,
    RouterModule,
    NgxCurrencyDirective,
    EmptyStateComponent,
    AbntPipe,
  ],
  templateUrl: './produto-custos.component.html',
  styleUrl: './produto-custos.component.css',
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
    { provide: DateAdapter, useClass: CustomDateAdapter },
  ],
})
export class ProdutoCustosComponent {
  @Input({ required: true }) form!: FormGroup;
  @Input() defaultCurrencyMask: any;
  @Input() dynamicCurrencyMask: any;
  /** Custo médio atual do produto, do estoque (última movimentação); somente leitura. */
  @Input() custoMedioAtual: number | null = null;
  @Input() set dadosCustosCarregados(dados: any[]) {
    if (dados) {
      this.custos.clear();
      dados.forEach(item => this.addCustoRow(item));
    }
  }
  constructor(private fb: FormBuilder) { }

  get custos(): FormArray {
    return this.form.get('custos') as FormArray;
  }

  getControl(item: any, controlName: string): FormControl {
    return item.get(controlName) as FormControl;
  }

  addCustoRow(data?: any): void {
    const group = this.fb.group({
      idProdutoCustoHistorico: [data?.idProdutoCustoHistorico],
      dataVigencia: [this.converterDataApiParaDate(data?.dataVigencia), Validators.required],
      precoCusto: [data?.precoCusto, Validators.required],
      impostosRecuperaveis: [data?.impostosRecuperaveis],
      idNFeEntrada: [data?.idNFeEntrada],
    });
    this.custos.push(group);
  }
  removeCustoRow(index: number): void {
    this.custos.removeAt(index);
  }

  onDateInput(event: Event): void {
    MaskService.onDateInput(event);
  }

  /**
   * A vigência do custo é um dia ("yyyy-MM-dd"): lê como data local, porque `new Date('2026-10-23')` é UTC e, no Brasil,
   * mostraria o dia anterior.
   */
  private converterDataApiParaDate(valor: Date | string | null | undefined): Date | null {
    if (!valor) return null;
    if (valor instanceof Date) return valor;
    const [ano, mes, dia] = valor.substring(0, 10).split('-').map(Number);
    if (!ano || !mes || !dia) return null;
    return new Date(ano, mes - 1, dia);
  }
}
